import React, { Fragment } from "react";
import Grid from "@material-ui/core/Grid";
import ImgMediaCard from "components/Project/ImageCard";
import ProjectPagination from "./../../General/ProjectPagination";
import { paginate } from "../../../utils/paginate";
import { withRouter } from "react-router";

class ProjectGrid extends React.Component {
  state = {
    pageSize: 10,
    currentPage: 1,
  };
  projectSelectedHandler(value) {
    if(value === 'create-your-own-project'){
      const newWindow = window.open('https://katamundi.org/2020/07/04/katamundi-impact-project-application/', '_blank', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null
    }
    else{
      this.props.history.push({
        pathname: "projects/" + value,
      });
    }
  }

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  render() {
    const projectNewData = this.props.projectData
    const fromIndex = projectNewData.map(i => i?.slug).indexOf("create-your-own-project");
    let obj = projectNewData[fromIndex];
    projectNewData.splice(fromIndex,1);
    projectNewData.splice(0,0,obj);
    let filtered = projectNewData;

    if (this.props.selected !== "") {
      filtered = projectNewData.filter((project) =>
        project.category.includes(this.props.selected)
      );
    }
    const projectPaginated = paginate(
      filtered,
      this.state.currentPage,
      this.state.pageSize
    );
    return (
      <Fragment>
        <Grid
          container
          spacing={2}
          direction="row"
          justify="flex-start"
          alignItems="flex-start"
        >
          {projectPaginated
            // .sort((a, b) => (a.name > b.name ? 1 : -1))
            .map((elem) => {
              return (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  key={projectNewData.indexOf(elem)}
                >
                  <ImgMediaCard
                    projectData={elem}
                    imageSrc={elem?.banner}
                    imageId={elem?.slug}
                    onClick={this.projectSelectedHandler.bind(this)}
                  />
                </Grid>
              );
            })}
        </Grid>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // marginTop: "30px",
          }}
        >
          <ProjectPagination
            // itemsCount={this.props.projectData.length}
            itemsCount={filtered.length}
            pageSize={this.state.pageSize}
            onPageChange={this.handlePageChange}
            currentPage={this.state.currentPage}
          />
        </div>
      </Fragment>
    );
  }
}
ProjectGrid = withRouter(ProjectGrid);
export default ProjectGrid;
